export const stockOnHandStatuses = [
  {
    id: 'Select All',
    checked: false,
    value: 'Select All',
  },
  {
    id: 'Overstocked',
    checked: false,
    value: 'Overstocked',
  },
  {
    id: 'Sufficient Stock',
    checked: false,
    value: 'Sufficient Stock',
  },
  {
    id: 'Urgently Reduce Stock',
    checked: false,
    value: 'Urgently Reduce Stock',
  },
  {
    id: 'Running Low',
    checked: false,
    value: 'Running Low',
  },
  {
    id: 'Out Of Stock',
    checked: false,
    value: 'Out Of Stock',
  },
  {
    id: 'Dead Stock',
    checked: false,
    value: 'Dead Stock',
  },
]
